import { useState } from 'react';
import { CButton } from '@coreui/react';
import { NumberInput } from '@trading/ui-table';
import type { PositionRow } from './types.js';

interface Props {
    row: PositionRow;
    onSetOverride: (symbol: string, target: number | null) => void;
}

const roundToCents = (value: number): number => Math.round(value * 100) / 100;

export const TargetOverrideCell = ({ row, onSetOverride }: Props) => {
    const [pendingValue, setPendingValue] = useState(roundToCents(row.target ?? 0));

    return (
        <div className="d-flex align-items-center gap-1" onClick={(e) => e.stopPropagation()}>
            <NumberInput
                size="sm"
                style={{ width: 90 }}
                step={0.01}
                value={pendingValue}
                onChange={setPendingValue}
                min={0}
            />
            <CButton
                size="sm"
                color="primary"
                variant="outline"
                onClick={() => onSetOverride(row.symbol, roundToCents(pendingValue))}
            >
                Set
            </CButton>
            {row.targetSource === 'manual' && (
                <CButton
                    size="sm"
                    color="secondary"
                    variant="outline"
                    onClick={() => onSetOverride(row.symbol, null)}
                >
                    Clear
                </CButton>
            )}
        </div>
    );
};
